const forMembersResources = {
    title: 'For Members',
};
export default forMembersResources;